export const container = 'p-4 md:px-6 md:mx-7';
export const homeText = 'text-xl';
export const gridContainer = 'grid grid-cols-1 md:grid-cols-2 my-4 gap-10';
export const leftGrid = 'w-full lg:w-3/5';
export const sectionTitle = 'text-lg font-semibold mb-4';
export const sectionSubtitle = 'text-xs';
export const testModeText = 'text-red-500';
export const cardContainer = 'my-4 border';
export const selectedCardBorder = 'border-custom-button-green';
export const unselectedCardBorder = 'border-transparent';
export const cardContent = 'flex justify-between items-center';
export const cardText = 'flex-1 px-2';
export const userIcon = 'h-8 w-8';
export const progressBarContainer = 'w-full bg-gray-200 rounded-lg';
export const progressBar = 'bg-custom-button-green rounded-full h-2';
export const checkIconContainer = 'rounded-full flex justify-center items-center h-6 w-6 p-1 bg-custom-button-green';
export const checkIcon = 'text-white';
export const goLiveContainer = 'mt-4 bg-black flex items-center justify-center flex-wrap p-2 gap-4 rounded-lg cursor-pointer';
export const goLiveText = 'text-white';
export const goLiveButton = 'bg-gray-200 text-gray-800 p-2 rounded';
export const childrenContainer = '';
export const unselectedCardIcon ='rounded-full h-6 w-6 p-1 bg-gray-200 shadow-lg mt-0'
